/* eslint-disable react/no-danger */

/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import useScrollToTop from '../../hooks/useScrollToTop';
import * as AppPropTypes from '../../lib/PropTypes';

import Blocks from '../blocks/Blocks';
import Header from '../headers/Header';
import AwardsList from '../lists/AwardsList';

import styles from '../../../styles/pages/page.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
    className: PropTypes.string,
    children: PropTypes.node,
};

const defaultProps = {
    className: null,
    children: null,
};

const PrizesPage = ({ page, className, children }) => {
    const { blocks = [], awards = null, edition = null } = page;
    useScrollToTop(page);
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <Header page={page} type="page" />
            {awards !== null && awards.length > 0 ? (
                <div
                    className={classNames([
                        styles.inner,
                        styles.centered,
                        styles.wideColumn,
                        styles.blocks,
                    ])}
                >
                    <AwardsList items={awards.map((award) => ({ edition, ...award }))} short />
                </div>
            ) : null}
            {(blocks || []).length > 0 ? (
                <div className={styles.inner}>
                    <Blocks blocks={blocks} className={styles.blocks} isContainer />
                </div>
            ) : null}
            {children}
        </div>
    );
};
PrizesPage.propTypes = propTypes;
PrizesPage.defaultProps = defaultProps;

export default PrizesPage;
